export enum AccommodationFilterOptions {
  All = 0,
  NotOnValidWeekRests = 1,
  NotOnLongRests = 2,
}
